import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import NotificationsItem from '../NotificationItem/NotificationItem';
import styles from './TaskManagementCard.scss';

const TaskManagementCard = ({
  notification,
  close,
  action,
  taskItemAction,
  notificationData,
  staticTexts,
  onClickMarkAsRead,
}) =>{
    const { data } = notification;
 
    const title = get(notificationData, `taskStatusChanged.${notification.type}.title`, '')
    const taskAction = get(notificationData, `taskStatusChanged.${notification.type}.action`, '')
    const result = get(notificationData, `taskStatusChanged.${notification.type}.result`, '')
    const taskTitle = get(data, 'taskTitle', '');
    const assigneeName = get(data, 'assigneeName', '');
    const adminName =get(data, 'adminName', '');

    return (
        <NotificationsItem
            notification={notification}
            close={close}
            action={action}
            taskItemAction={taskItemAction}
            notificationData={notificationData}
            staticTexts={staticTexts}
            onClickMarkAsRead={onClickMarkAsRead}
            taskCardTitle={title}
            isTaskItem={true}
        >
            <div className={styles.message}>
                <div className={styles.keyWord}>{adminName}</div>&nbsp;
                {taskAction}&nbsp;
                { 
                    notification.type !== 'taskCompleted' ?
                    <React.Fragment>
                        <div className={styles.keyWord}>{assigneeName}</div>&nbsp;
                        {result}&nbsp;
                        <div className={styles.keyWord}>{taskTitle}</div>
                    </React.Fragment>
                    :
                    <React.Fragment>
                        <div className={styles.keyWord}>{taskTitle}</div>&nbsp;
                        {result}
                    </React.Fragment>
                }     
            </div>
        </NotificationsItem>
    )
}

TaskManagementCard.propTypes = {
  notification: PropTypes.shape({
    createdAt: PropTypes.string,
    type: PropTypes.string,
    seen: PropTypes.bool,
    data: PropTypes.object,
  }).isRequired,
  close: PropTypes.func.isRequired,
  action: PropTypes.func.isRequired,
  notificationData: PropTypes.shape({
    requestSubmitted: PropTypes.shape({
        staticText: PropTypes.string
    })
  }).isRequired,
  staticTexts: PropTypes.shape({
    markAsRead: PropTypes.string,
    markAsUnread: PropTypes.string,
  }).isRequired,
  onClickMarkAsRead: PropTypes.func.isRequired,
};

export default TaskManagementCard;
